import React from 'react';
import { ServiceSelect } from "../../features/ServiceSelect";
import styled from "styled-components";

const ActivRoot = styled.div`
    margin-top: 120px;
    h1 {
        margin-bottom: 25px;
				text-align: start;
    }
    @media screen and (max-width: 640px) {
        margin-top: 20px;
    }
`

const Activ = ({ lang }) => {
	return (
		<ActivRoot>
			<ServiceSelect type="activ" lang={lang}/>
		</ActivRoot>
	);
};

export default Activ;
